export enum EntityStatusEnum {
  draft = 'Draft',
  published = 'Published',
  live = 'Live',
  expired = 'Expired',
  error = 'Error',
  processing = 'Processing',
}
